import React, { useRef } from 'react'

import { Form, Input, Modal, Typography } from 'antd'

const { Title, Text } = Typography

const { TextArea } = Input

const ContactSocialForm = ({ visible, onSubmit, onCancel, data }) => {
  //destructures props
  const [form] = Form.useForm()
  const formRef = useRef()

  return (
    <Modal
      visible={visible}
      title='Edit Social Media Links'
      okText='Save'
      onCancel={onCancel}
      width={'66vw'}
      style={{ top: 20 }}
      onOk={() => {
        onSubmit(form.getFieldsValue())
      }}
    >
      <div
        style={{
          width: '100%',
          height: '50vh',
          paddingTop: 6,
          paddingBottom: 6,
          paddingRight: 24,
          overflowY: 'auto',
          overflowX: 'hidden'
        }}
      >
        <Form
          form={form}
          requiredMark={'optional'}
          layout={'vertical'}
          initialValues={{
            social_instagram: data?.social_instagram,
            social_facebook: data?.social_facebook,
            social_linkedin: data?.social_linkedin
          }}
        >
          <Form.Item
            name={'social_instagram'}
            label={'Instagram'}
            rules={[
              {
                required: false,
                type: 'string',
                max: 1024,
                min: 0
              }
            ]}
          >
            <Input addonBefore='https://' />
          </Form.Item>
          <Form.Item
            name={'social_facebook'}
            label={'Facebook'}
            rules={[
              {
                required: false,
                type: 'string',
                max: 1024,
                min: 0
              }
            ]}
          >
            <Input addonBefore='https://' />
          </Form.Item>
          <Form.Item
            name={'social_linkedin'}
            label={'LinkedIn'}
            rules={[
              {
                required: false,
                type: 'string',
                max: 1024,
                min: 0
              }
            ]}
          >
            <Input addonBefore='https://' />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  )
}

export default ContactSocialForm
